<template>
  <v-card class="mt-5" height='100%'>
      <v-container fluid class="pa-5">
        <v-row>
          <v-col cols="12">
          <div
            class="font-weight-medium ml-5"
            style="font-size: 20px"
          >
            Investors performance table   
          </div>            
          </v-col>          
          <v-col cols="12" v-if="startDate">
            <p>Performance between {{startDate}} and {{endDate}}</p> <small>Based on investor's equity positions within our database. Computed in USD, ignoring transaction cost. Actual performance of these investors and funds might differ greatly.</small>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search Investors"
              single-line
              hide-details
            ></v-text-field>
          </v-col>          
          <v-col cols="12" v-if="items">
            <v-skeleton-loader v-if="listLoad" type="table"></v-skeleton-loader>
            <v-data-table
              :search="search"
              v-show="!listLoad"
              :headers="headers"
              :items="items"
              :mobile-breakpoint="0"
            >

              <template v-slot:item="row">
                <tr>
                  <td>
                      {{row.item.rank}}
                  </td>
                  <td><div class="d-flex align-center">
                      <v-btn
                        class="px-2 mr-2 mt-1" 
                        color="primary"
                        min-width="0"
                        icon
                        small
                        :to="'/investors/analyze/' + row.item.id"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on">
                              mdi-magnify-plus-outline
                            </v-icon>                        
                          </template>
                          <span>Analyze</span>
                        </v-tooltip> 
                      </v-btn>
                      {{row.item.investor}}
                    </div></td>                  
                  <td>{{row.item.classification}}</td>                                                 
                  <td class="text-right">{{ row.item.cumulative_return | numeral('0.0%') }}</td>
                  <td class="text-right">{{ row.item.intercept | numeral('0.0%') }}</td>
                  <td class="text-right">{{ row.item.factor_country | numeral('0.0%') }}</td>
                  <td class="text-right">{{ row.item.factor_sector | numeral('0.0%') }}</td>
                  <td class="text-right">{{ row.item.factor_value | numeral('0.0%') }}</td>
                  <td class="text-right">{{ row.item.factor_mom | numeral('0.0%') }}</td>
                  <td class="text-right">{{ row.item.factor_risk | numeral('0.0%') }}</td>
                  <td class="text-right">{{ row.item.factor_size | numeral('0.0%') }}</td>
                  <td class="text-right">{{ row.item.factor_quality | numeral('0.0%') }}</td>
                  <td class="text-right">{{ row.item.factor_fx | numeral('0.0%') }}</td>
                  <td class="text-right">{{ row.item.residuals | numeral('0.0%') }}</td>

                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>     
      </v-container>
    </v-card>
</template>

<script>
  export default {
    name: 'InvestorPerformanceTable',
    props: ['element','type'],
    data() {
      return {
        search:"",
        startDate: null,
        endDate: null,
        period: 3,
        headers: [
          { text: 'Rank', value: 'rank' }, 
          {
            text: 'Name',align: 'left',value: 'investor',
          },
          { text: 'Classification', value: 'classification' },          
          { text: 'Return', value: 'cumulative_return' },         
          { text: 'Market contrib', value: 'intercept' },         
          { text: 'Country contrib', value: 'factor_country' },         
          { text: 'Sector contrib', value: 'factor_sector' },         
          { text: 'Value contrib', value: 'factor_value' },         
          { text: 'Mom contrib', value: 'factor_mom' },         
          { text: 'Risk contrib', value: 'factor_risk' },         
          { text: 'Size contrib', value: 'factor_size' },         
          { text: 'Quality contrib', value: 'factor_quality' },         
          { text: 'FX contrib', value: 'factor_fx' },         
          { text: 'Stock specific (residuals)', value: 'residuals' },                 
        ],
        items: [
        ],
        listLoad: true,
        errorbar: false,        
      }
    },
    mounted () {
      this.getListFromApi()
    },    
    methods: {         
      async getListFromApi() {
        var self = this
        const currentSession = await this.$Amplify.Auth.currentSession()
        const currentToken = currentSession.getIdToken().getJwtToken()
        //console.log(process.env.VUE_APP_API_HOST + '/get-investors-performance-table/' + self.type + '/' + self.element)
        this.$http.get(process.env.VUE_APP_API_HOST + '/get-investors-performance-table/' + self.type + '/' + self.element,{
          headers: {
            'Authorization': currentToken,
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          //console.log(response.data)
          self.items = response.data.performance 
          self.startDate = response.data.min 
          self.endDate = response.data.max 
          self.period = response.data.period
          self.listLoad = false
        }).catch(function (/*error*/) {
          //console.log(error)
          self.listLoad = false
          //self.errorbar = true
        })
      }
    },
  }
</script>